import de from './locales/de';
import en from './locales/en';

export const messages = {
  'en-US': en,
  'de-DE': de,
};
